export class ConstructionMaster {
  ConstructionImageID: number;
  BlockName: string;
  BlockImagepath1: string;
  BlockImagepath2: string;
  ContentInfo: string;
  Ground: string;
  First: string;
  SecondtoLast: string;
}
